import axiosClient from '../axiosClient';

export const getPendingPayouts = () =>
  axiosClient.get('/admin/payouts');

export const processPayouts = (commissionIds) =>
  axiosClient.post('/admin/payouts/process', { commissionIds });

export const getPayoutHistory = (params) =>
  axiosClient.get('/admin/payouts/history', { params });
